<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block" style="display:flex">
        <div class="block" style="margin-left:20px;display:flex">
          <el-input placeholder="输入关键字模糊查询" v-model="keywordQuery" clearable></el-input>
          <el-select style="margin-left: 10px" v-model="stateVal" clearable placeholder="生效状态">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div style="margin-left:20px">
          <el-row>
            <el-button type="success" @click="searchFn">查询</el-button>
            <el-button type="primary" @click="goDetails">新增公告</el-button>
          </el-row>
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="title" label="公告标题"></el-table-column>
        <el-table-column prop="add_time" label="创建时间" :formatter="addTime" sortable></el-table-column>
        <el-table-column prop="active_time_begin" label="生效开始时间">
          <template slot-scope="scope">
            {{timestampToTime(scope.row.active_time_begin)}}
          </template>
        </el-table-column>
        <el-table-column prop="active_time_end" label="生效结束时间">
          <template slot-scope="scope">
            {{timestampToTime(scope.row.active_time_end)}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="生效状态">
          <template slot-scope="scope">
            {{scope.row.status == "1" ? "生效中":"未生效"}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-row>
              <el-button type="text" size="small" @click="editDetails(scope.row)">
                <i class="el-icon-edit"></i>编辑
              </el-button>
              
              <el-button type="text" size="small" @click="deleteFn(scope.row)">
                <i class="el-icon-delete"></i>删除
              </el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalList"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import api from "./api";
import {timestampToTime} from "@/mixins/tools.js"

export default {
  mixins: [timestampToTime],
  name: "CountryBase",
  data() {
    return {
      loading: false,
      keywordQuery: "",
      tableData: [],
      currentPage: 1,
      totalList: null,
      stateVal: '',
      options: [{
          value: '1',
          label: '生效中'
        }, {
          value: '2',
          label: '未生效'
        }
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData() {
      this.loading = true;
      let datas = {
        q: this.keywordQuery,
        status: this.stateVal
      }
      api
        .noticeList(datas)
        .then(res => {
          console.log(res)
          this.loading = false;
          this.tableData = res.list;
          this.totalList = res.recordcount;
          this.pageSize = res.pagecount;
        })
        .catch(err => {
          this.$message(err);
        });
    },

    // 查询 searchFn
    searchFn() {
      this.getData()
    },
   
    // 编辑操作
    editDetails(row) {
      let routeData = this.$router.resolve({
        name: "AnnouncementsData",
        query: {
          id: row.id
        }
      });
      window.open(routeData.href, '_blank');
    },

    // 删除
    deleteFn(row) {
      let datas = {
        id: row.id
      }
      this.$confirm('确定要删除吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         api.deleteFn(datas)
          .then(res => {
            if(res.error_code == 0) {
              this.$message.success("删除成功！")
            }
            this.getData()
          })
          .catch(err => {
            
          });
      }).catch(() => {
      });
    },

    // 跳转详情页
    goDetails() {
      this.$router.push({
        name: "AnnouncementsData"      
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 100px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>